/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineClassModulesQueryResponse,
  GetApiV1ClassroomdisciplineClassModulesQueryParams,
  GetApiV1ClassroomdisciplineClassModules401,
  GetApiV1ClassroomdisciplineClassModules500,
} from "../../types/classPlanningClassModuleController/GetApiV1ClassroomdisciplineClassModules.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineClassModules } from "../../clients/classPlanningClassModuleController/getApiV1ClassroomdisciplineClassModules.ts";

export const getApiV1ClassroomdisciplineClassModulesQueryKey = (
  params?: GetApiV1ClassroomdisciplineClassModulesQueryParams,
) =>
  [
    { url: "/api/v1/classroomdiscipline/class-modules" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ClassroomdisciplineClassModulesQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineClassModulesQueryKey
>;

export function getApiV1ClassroomdisciplineClassModulesQueryOptions(
  params?: GetApiV1ClassroomdisciplineClassModulesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ClassroomdisciplineClassModulesQueryKey(params);
  return queryOptions<
    GetApiV1ClassroomdisciplineClassModulesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineClassModules401
      | GetApiV1ClassroomdisciplineClassModules500
    >,
    GetApiV1ClassroomdisciplineClassModulesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineClassModules(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Lista paginada de Módulos com filtros opcionais: CompanyId, Description (parcial), DateStart, DateFinish e ClassStudentId. **(Requer Authorization para autenticação)**
 * @summary Listar Módulos (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/class-modules}
 */
export function useGetApiV1ClassroomdisciplineClassModules<
  TData = GetApiV1ClassroomdisciplineClassModulesQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineClassModulesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ClassroomdisciplineClassModulesQueryKey,
>(
  params?: GetApiV1ClassroomdisciplineClassModulesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineClassModulesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ClassroomdisciplineClassModules401
          | GetApiV1ClassroomdisciplineClassModules500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineClassModulesQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineClassModulesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineClassModules401
      | GetApiV1ClassroomdisciplineClassModules500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
